import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Container, Row, Col } from "shards-react";

import { Store } from "../flux";
import MainNavbar from "../components/layout/MainNavbar/MainNavbar";
import MainSidebar from "../components/layout/MainSidebar/MainSidebar";
import UserSidebar from "../components/layout/MainSidebar/UserSidebar";
import SuperAdminSidebar from "../components/layout/MainSidebar/SuperAdminSidebar";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScaleLoader from "react-spinners/ScaleLoader";

import { USER_ROLES, AuthRoutes, SuperadminRoutes, AdminRoutes, UserRoutes } from "./../routes";
import { useIsAuthenticated } from "@azure/msal-react";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#004A7C",
  position: "fixed",
  height: "100%",
  width: "100%",
  opacity: "0.8",
  backgroundColor: "#000",
  zIndex: "9999",
  marginLeft: "-15px",
  paddingTop: "20%",
  paddingLeft: "50%",
};

const DefaultLayout = ({ appState, auth, sso }) => {
  const [menuVisible, set_menuVisible] = useState(Store.getMenuState());
  /* const [authenticated, set_authenticated] = useState(false);
  const [authValidating, set_authValidating] = useState(false);
  const [userRole, set_userRole] = useState(""); */

  const isAuthenticated = useIsAuthenticated();

  /* useEffect(() => {
    let authentic = false,
      validating = false,
      role = "";
    console.log("Default isAuthenticated => ", isAuthenticated);
    if (auth.authToken) {
      authentic = true;
      if (auth.isLoggedIn) role = auth.user.role ? auth.user.role : USER_ROLES.user;
      else validating = true;
    }
    // else if (isAuthenticated) {
    //   authentic = true;
    //   role = USER_ROLES.user;
    // }
    set_authenticated(authentic);
    set_authValidating(validating);
    set_userRole(role);
  }, [auth]); // isAuthenticated */

  useEffect(() => {
    Store.addChangeListener(onChange);
    return () => Store.removeChangeListener(onChange);
  }, []);

  function onChange() {
    set_menuVisible(Store.getMenuState());
  }

  const lg_size = menuVisible ? 10 : 12;
  const lg_offset = menuVisible ? 2 : 0;
  const md_size = menuVisible ? 9 : 12;
  const md_offset = menuVisible ? 3 : 0;

  const SUB_DOMAIN = process.env.REACT_APP_SUB_DOMAIN;

  return (
    <Router basename={SUB_DOMAIN}>
      <Container fluid>
        <ScaleLoader cssOverride={override} size={40} color={"#1484cd"} loading={appState.loading} speedMultiplier={1.5} />
        {auth.authToken ? (
          !auth.isLoggedIn ? (
            <ScaleLoader cssOverride={override} size={40} color={"#1484cd"} loading={true} speedMultiplier={1.5} />
          ) : auth.user && auth.user.role === USER_ROLES.superadmin ? (
            <Row>
              <SuperAdminSidebar />
              <Col
                className="main-content p-0"
                lg={{ size: lg_size, offset: lg_offset }}
                md={{ size: md_size, offset: md_offset }}
                sm="12"
                tag="main"
              >
                <MainNavbar />
                <Switch>
                  {SuperadminRoutes.map((route, index) => {
                    return (
                      <Route
                        key={"route-" + index}
                        path={route.path}
                        exact={route.exact || true}
                        component={route.component}
                      />
                    );
                  })}
                </Switch>
              </Col>
            </Row>
          ) : auth.user && auth.user.role === USER_ROLES.admin ? (
            <Row>
              <MainSidebar />
              <Col
                className="main-content p-0"
                lg={{ size: lg_size, offset: lg_offset }}
                md={{ size: md_size, offset: md_offset }}
                sm="12"
                tag="main"
              >
                <MainNavbar />
                <Switch>
                  {AdminRoutes.map((route, index) => {
                    return (
                      <Route
                        key={"route-" + index}
                        path={route.path}
                        exact={route.exact || true}
                        component={route.component}
                      />
                    );
                  })}
                </Switch>
              </Col>
            </Row>
          ) : (
            <Row>
              <UserSidebar />
              <Col
                className="main-content p-0"
                lg={{ size: lg_size, offset: lg_offset }}
                md={{ size: md_size, offset: md_offset }}
                sm="12"
                tag="main"
              >
                <MainNavbar />
                <Switch>
                  {UserRoutes.map((route, index) => {
                    return (
                      <Route
                        key={"route-" + index}
                        path={route.path}
                        exact={route.exact || true}
                        component={route.component}
                      />
                    );
                  })}
                </Switch>
              </Col>
            </Row>
          )
        ) : (
          <Row>
            <Col className="" sm="12" tag="main">
              <Switch>
                {AuthRoutes.map((route, index) => {
                  return (
                    <Route
                      key={"route-" + index}
                      path={route.path}
                      exact={route.exact || true}
                      component={route.component}
                    />
                  );
                })}
              </Switch>
            </Col>
          </Row>
        )}
        <ToastContainer />
      </Container>
    </Router>
  );
};

export default DefaultLayout;
